<template>
  <default-textual-section v-if="$store.state.displayType === 'textual'" :menu="menu" :section="section"
                           menu-item-component="high-limit-food-item"
                           class="menu--section-high_limit"></default-textual-section>
  <default-visual-section v-else :menu="menu" :section="section"
                          menu-item-component="high-limit-food-item"
                          class="menu--section-high_limit"></default-visual-section>
</template>

<script lang="ts">
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-04-21 (1.0.0) (jhoward)
 *    - Copy from Bimini_default.vue component to HighLimit_default.vue component.
 *
 *  2023-06-19 (1.1.0) (jhoward)
 *    - Support section.ms_show_pricing_header in <HighLimit_defaultSection>.
 *
 *  2023-08-23 (1.2.0) (jhoward)
 *    - Use <menu-version> in <HighLimit_defaultSection>.
 *
 *  2025-02-11 (1.3.0) (jhoward)
 *    - Add <menu-schedules> to the <HighLimit_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <HighLimit_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <HighLimit_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "HighLimit_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
</script>

<style scoped>
.menu--section-high_limit,
.visual_menu--section.menu--section-high_limit,
.visual_menu--container-landscape .visual_menu--section.menu--section-high_limit {
  margin: 0 auto;
  padding-top: 0.5em;
  color: #3d1514;
}

.visual_menu--section .menu--section-high_limit,
.visual_menu--container-landscape .visual_menu--section .menu--section-high_limit {
  font-size: 0.8em;
  padding-left: 7em;
  padding-right: 10em;
}

.menu--section-high_limit:deep(.menu--section_title) {
  color: #825327;
  padding: 0 1em;
  text-align: center;
  position: relative;
  overflow: initial;
  font-family: proxima-nova, sans-serif;
  font-style: normal;
  letter-spacing: 0.05em;
  font-size: 1.8em;
}

.visual_menu--section.menu--section-high_limit:deep(.menu--section_title) {
  margin: 2rem 0 0.9em 0;
}

.menu--section-high_limit:deep(.menu--section_subtitle) {
  font-size: 1em;
  font-weight: 400;
  margin-bottom: 0.4em;
  text-align: center;
}

.visual_menu--section.menu--section-high_limit:deep(.menu--section_subtitle) {
  margin-top: -2em;
}

.menu--section-high_limit.menu--section-highlight {
  background-color: #f7f3eb;
}

.menu--section-high_limit:deep(.menu--item-highlighted_box .menu--item_description) {
  font-size: 0.9em;
  line-height: 1.2em;
}
</style>